module.exports = __webpack_public_path__ + "static/Ola_1_min-41bc55ceddcb20b883e39a7874757792.jpg";